module.exports = __webpack_public_path__ + "static/media/img_suss_close.b62741cf.png";